import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import RemoveBundleButton from '../RemoveBundleButton';
import { replaceTokensInString } from '@app/utils';
import ExceptionFeedback from '@app/components/common/Exception/ExceptionFeedback';
import { FEEDBACK_TYPES } from '@app/constants/errorConstants';
import styles from './BundleError.module.scss';
import cn from 'classnames';

const BundleError = ({ orderItems }) => {
  const [t] = useTranslation();
  const orderItemsWithErrors = orderItems.filter(item => item.hasBundleError);
  const isSingleBundleError = orderItemsWithErrors.length === 1;
  const bundleKitQuantity = t('BUNDLES_KIT_QUANTITY');
  const bundleToRemoveMessage = t('NUMBER_BUNDLES_REMOVED');

  const title =
    orderItemsWithErrors.length > 1 ? (
      <span
        className={`mb-2 text-sm u-color--DarkGray ${styles['multiple-bundle-error-title']}`}
      >
        {t('BUNDLES_QUANTITY_ERRORS')}
      </span>
    ) : null;
  return orderItemsWithErrors?.length > 0 ? (
    <div className="py-2">
      <ExceptionFeedback
        title={title}
        type={FEEDBACK_TYPES.ERROR}
        className={cn({
          'mb-0': orderItemsWithErrors.length
        })}
      >
        {orderItemsWithErrors.map(item => {
          const {
            name,
            quantity,
            orderItemId,
            partNumber,
            orderItemExtendAttribute
          } = item;
          const itemName = `${partNumber}: ${name}`;
          const ssroBundle = orderItemExtendAttribute.ssroBundle;
          const associatedBundleCount = ssroBundle.length;
          const bundlesToRemoveCount =
            associatedBundleCount - parseInt(quantity);
          const rowIndex =
            orderItems.findIndex(
              orderItem => orderItem.orderItemId === orderItemId
            ) + 1;
          const errorMessage = replaceTokensInString(
            t('MULTIPLE_NUMBER_BUNDLES_REMOVED'),
            itemName,
            rowIndex,
            bundlesToRemoveCount
          );
          const bundleKitQuantityErrorMessage = replaceTokensInString(
            bundleKitQuantity,
            itemName
          );
          const bundleCountRemoveMessage = replaceTokensInString(
            bundleToRemoveMessage,
            bundlesToRemoveCount
          );
          const singleBundleErrorMessage = `${bundleKitQuantityErrorMessage}${bundleCountRemoveMessage}`;
          return (
            <Fragment key={partNumber}>
              <p className="mt-0">
                {isSingleBundleError ? singleBundleErrorMessage : errorMessage}
              </p>

              <RemoveBundleButton
                name={!isSingleBundleError ? partNumber : ''}
                orderItemId={orderItemId}
                associatedBundleCount={associatedBundleCount}
                ssroBundle={ssroBundle}
                bundlesToRemoveCount={bundlesToRemoveCount}
              />
            </Fragment>
          );
        })}
      </ExceptionFeedback>
    </div>
  ) : null;
};

BundleError.propTypes = {
  orderItems: PropTypes.arrayOf(
    PropTypes.shape({
      hasBundleError: PropTypes.bool
    })
  )
};

export default BundleError;
